import { render, staticRenderFns } from "./zcfbhz.vue?vue&type=template&id=4e586f4a"
import script from "./zcfbhz.vue?vue&type=script&lang=js"
export * from "./zcfbhz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports